import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/shared/header";
import { RxCaretLeft } from "react-icons/rx";

const DISPLAY_FONT = "'Anton', 'Oswald', 'Arial Narrow', sans-serif";

const Collection = () => {
  return (
    <main className="min-h-screen bg-[#0A0A0A] font-sans text-[#EDEAE1]">
      <Header />

      <div className="mx-auto flex min-h-[calc(100vh-3rem)] max-w-6xl flex-col items-center justify-center px-6 text-center">
        <p
          style={{ fontFamily: DISPLAY_FONT }}
          className="mb-3 text-sm uppercase text-[#D0182B]"
        >
          Official Fighter Collabs
        </p>

        <h1
          style={{ fontFamily: DISPLAY_FONT }}
          className="mb-6 text-5xl uppercase leading-[0.92] tracking-tight text-[#EDEAE1] md:text-8xl"
        >
          Coming Soon
        </h1>

        <div className="mb-8 h-1 w-24 bg-[#D0182B]" />
        <p className="mb-10 max-w-md text-base leading-relaxed text-[#8C8880]">
          Fighter odds, exclusive merchandise and matchup markets are in training
          camp. This one drops when it's ready to fight.
        </p>

        <Link
          to="/"
          style={{ fontFamily: DISPLAY_FONT }}
          className="inline-flex items-center gap-2 border border-[#D0182B] text-[#D0182B] font-semibold hover:bg-[#D0182B] hover:text-[#EDEAE1] hover:font-semibold px-7 py-3.5 text-sm uppercase tracking-wide transitionAll"
        >
          <RxCaretLeft size="14" fontWeight="bold" /> Back to Home
        </Link>
      </div>
    </main>
  );
};

export default Collection;